module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "landing-banner"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'OSS Configs',
          exact: true,
          to: {
            path: '/landing-banners'
          },
        },
        {
          text: 'Banner Landing Page',
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Banner Landing Page")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v(" Daftar Banner ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.Banners,
      "headers": _vm.headers,
      "hasDetail": true,
      "custom-pagination-total-items": _vm.Banners.length,
      "custom-pagination-per-page": 10,
      "custom-pagination-current-page": 1
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editliveClass()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54b9a33a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/oss_configs/components/landing_banners/ListBanner.vue
// module id = 1946
// module chunks = 1